export const userType = {
  internal: 1,
  external: 2
};
